import React, { useState } from 'react';
import { Card } from '../components/ui/card';
import { ChevronDown, ChevronUp } from 'lucide-react';
import SEO from '../components/SEO';

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What services do you offer?',
      answer: 'We offer comprehensive psychiatric services including psychiatric evaluation, medication management, mood disorder treatment, anxiety and trauma care, binge eating and impulse regulation support, and integrated medication support.'
    },
    {
      question: 'Do you accept insurance?',
      answer: 'Yes, we accept most major insurance plans including Aetna, Anthem Blue Cross Blue Shield, Cigna, UnitedHealthcare, and CareFirst for Maryland and Georgia patients. Tennessee and DC are currently self-pay only. Self-pay patients can use Reimbursify to submit claims to their insurance.'
    },
    {
      question: 'What states do you serve?',
      answer: 'We provide telehealth psychiatric services to patients in Tennessee, Georgia, Maryland, and the District of Columbia.'
    },
    {
      question: 'What ages do you treat?',
      answer: 'We provide comprehensive psychiatric care for patients ages 5 and up, including children, adolescents, and adults across the lifespan.'
    },
    {
      question: 'Are appointments conducted via telehealth?',
      answer: 'Yes, all appointments are conducted via secure telehealth video visits, allowing you to receive care from the comfort of your home.'
    },
    {
      question: 'What should I expect at my first appointment?',
      answer: 'Your first appointment is a comprehensive 60-minute psychiatric evaluation where we will discuss your mental health history, current concerns, and develop a personalized treatment plan. Please complete all intake paperwork at least 48 hours before your visit.'
    },
    {
      question: 'How do I prepare for my appointment?',
      answer: 'Complete intake paperwork at least 48 hours before your visit, find a quiet and private space, have your insurance card ready (if applicable), list current medications, and log into the patient portal 5 minutes early.'
    },
    {
      question: 'Do you prescribe controlled substances?',
      answer: 'Yes, when clinically appropriate and indicated, we can prescribe controlled substances as part of a comprehensive treatment plan with proper monitoring and follow-up.'
    },
    {
      question: 'What is your cancellation policy?',
      answer: 'We require 24-hour notice for cancellations or rescheduling. Late cancellations or no-shows may incur a fee. Please contact us as soon as possible if you need to change your appointment.'
    },
    {
      question: 'How often will I need follow-up appointments?',
      answer: 'Follow-up frequency depends on your individual needs and treatment plan. Initially, follow-ups may be every 2-4 weeks, then extend to monthly or quarterly once stable.'
    }
  ];

  return (
    <main className="pt-24 bg-[#FDFDFB]">
      <SEO 
        title="Frequently Asked Questions"
        description="Common questions about our psychiatric services, insurance, appointments, and what to expect during your care journey."
        keywords="psychiatric FAQs, mental health questions, insurance questions, telehealth appointments"
      />

      <section className="py-16 bg-gradient-to-b from-[#f7f4f0] to-[#FDFDFB]">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="text-5xl font-bold text-[#7a8a72] mb-6">Frequently Asked Questions</h1>
            <p className="text-xl text-[#3a3a3a]">
              Find answers to common questions about our services
            </p>
          </div>

          <div className="max-w-4xl mx-auto space-y-4">
            {faqs.map((faq, index) => (
              <Card key={index} className="bg-white border-[#d4cec5] overflow-hidden">
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full p-6 text-left flex items-center justify-between hover:bg-[#f7f4f0] transition-colors"
                >
                  <h3 className="text-lg font-semibold text-[#7a8a72] pr-4">{faq.question}</h3>
                  {openIndex === index ? (
                    <ChevronUp className="text-[#7a8a72] flex-shrink-0" size={24} />
                  ) : (
                    <ChevronDown className="text-[#7a8a72] flex-shrink-0" size={24} />
                  )}
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-6">
                    <p className="text-[#3a3a3a] leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </Card>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default FAQs;